import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { QuizAnswersDataService, QuizAnswersColumnsService } from '../../../services';
import { QuizAnswer, QuizAnswersResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-quiz-answer-details',
  templateUrl: './quiz-answer-details.component.html',
  styleUrls: ['./quiz-answer-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class QuizAnswerDetailsComponent implements OnInit, OnDestroy {

  public quizAnswer: QuizAnswer = {};
  public quizAnswers: QuizAnswer[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private quizAnswersDataService: QuizAnswersDataService,
    private quizAnswersColumnsService: QuizAnswersColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Quiz Answer - Details');
        this.getQuizAnswer(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizAnswer !== 'undefined') {
      this.quizAnswer = this.dynamicDialogConfig.data.quizAnswer;
    }
    this.columns = this.quizAnswersColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getQuizAnswer(id: number): void {
    this.isLoading = true;
    this.quizAnswersDataService.getQuizAnswer(id).subscribe((response: QuizAnswer|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizAnswer = response;
      }
    });
  }

  list() {
    this.router.navigate(['/quiz-answers']);
  }

  add() {
    this.router.navigate(['/quiz-answers/add']);
  }

  edit() {
    this.router.navigate(['/quiz-answers/edit/' + this.quizAnswer.id]);
  }

}
@Component({
  selector: 'app-quiz-answer-details',
  templateUrl: './quiz-answer-details.component.html',
  styleUrls: ['./quiz-answer-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogQuizAnswerDetailsComponent extends QuizAnswerDetailsComponent {
}

